const fixedIncomeRiskRating = {
  title: 'Classificação de risco',
  fieldName: 'riskRatingLevel',
  options: [
    { label: 'Risco Muito Baixo', value: 'RISCOMUITOBAIXO' },
    { label: 'Risco Baixo', value: 'RISCOBAIXO' },
    { label: 'Risco Médio', value: 'RISCOMEDIO' },
    { label: 'Risco Alto', value: 'RISCOALTO' },
    { label: 'Risco Muito Alto', value: 'RISCOMUITOALTO' },
  ],
};

const fundRiskRating = {
  title: 'Classificação de risco',
  fieldName: 'riskRatingLevel',
  options: [
    { label: 'Risco Muito Baixo', value: 'VeryLowRisk' },
    { label: 'Risco Baixo', value: 'LowRisk' },
    { label: 'Risco Médio', value: 'MediumRisk' },
    { label: 'Risco Alto', value: 'HighRisk' },
    { label: 'Risco Muito Alto', value: 'VeryHighRisk' },
  ],
};

const structuredOperationsRiskRating = {
  title: 'Classificação de risco',
  fieldName: 'riskRatingLevel',
  options: [
    { label: 'Alto', value: 'RISCOALTO' },
    { label: 'Muito Alto', value: 'RISCOMUITOALTO' },
  ],
};

const productSubCategory = {
  title: 'Subcategoria',
  fieldName: 'productSubCategory',
};

const productCategory = {
  title: 'Categorias',
  fieldName: 'productCategory',
};

const strategy = {
  title: 'Estratégia',
  fieldName: 'strategy',
};

const direction = {
  title: 'Direção',
  fieldName: 'direction',
};

const profitabilityType = {
  title: 'Tipo',
  fieldName: 'profitabilityType',
  options: [
    { label: 'Prefixado', value: 'PRE' },
    { label: 'Pós fixado(CDI)', value: 'POS' },
    { label: 'Inflação', value: 'INFLACAO' },
  ],
};

const dailyLiquidity = {
  title: 'Liquidez diária',
  fieldName: 'dailyLiquidity',
  isSingle: true,
  type: 'boolean',
  options: [
    { label: 'SIM', value: 'dailyLiquidity:true' },
    { label: 'NÃO', value: 'dailyLiquidity:false' },
  ],
};

const fgcProtected = {
  title: 'Proteção pelo FGC',
  fieldName: 'fgcProtected',
  isSingle: true,
  type: 'boolean',
  options: [
    { label: 'SIM', value: 'fgcProtected:true' },
    { label: 'NÃO', value: 'fgcProtected:false' },
  ],
};

const taxExempt = {
  title: 'IR',
  isSingle: true,
  type: 'boolean',
  fieldName: 'taxExempt',
  options: [
    { label: 'SIM', value: 'taxExempt:true' },
    { label: 'NÃO', value: 'taxExempt:false' },
  ],
};

const isInvestor = {
  title: 'Público alvo',
  fieldName: 'isInvestor',
  options: [
    { label: 'Investidor qualificado', value: 'QUALIFIED_INVESTOR' },
    { label: 'Investidor profissional', value: 'PROFESSIONAL_INVESTOR' },
  ],
};

// closedToApplicationDescription: true or nada
const closedToApplicationDescription = {
  title: 'Status',
  isSingle: true,
  type: 'boolean',
  fieldName: 'closedToApplicationDescription',
  options: [{ label: 'Aberto para aplicação', value: 'closedToApplicationDescription:true' }],
};

const quotationRedemptionOrLiquidityTerm = {
  title: 'Cotização do resgate e liquidação',
  fieldName: 'quotationRedemptionOrLiquidityTerm',
  isSingle: true,
  type: 'number',
  options: [
    { label: 'Até D+1', value: 'quotationRedemptionOrLiquidityTerm:1' },
    { label: 'Até D+10', value: 'quotationRedemptionOrLiquidityTerm:10' },
    { label: 'Maior que D+30', value: 'quotationRedemptionOrLiquidityTerm:31' },
  ],
  sideOptions: [
    { label: 'Até D+5', value: 'quotationRedemptionOrLiquidityTerm:5' },
    { label: 'Até D+30', value: 'quotationRedemptionOrLiquidityTerm:30' },
  ],
};

const directTreasuryRiskRatingLevel = {
  title: 'Classificação de risco',
  fieldName: 'riskRatingLevel',
};

const directTreasuryIndexerLevel = {
  title: 'Indexador',
  fieldName: 'indexer',
};

const semiAnnual = {
  title: 'Juros semestrais',
  fieldName: 'semiAnnual',
  isSingle: true,
  type: 'boolean',
  options: [
    { label: 'SIM', value: 'semiAnnual:true' },
    { label: 'NÃO', value: 'semiAnnual:false' },
  ],
};

export const FixedIncome = {
  fixedIncomeRiskRating,
  productSubCategory,
  profitabilityType,
  dailyLiquidity,
  fgcProtected,
  taxExempt,
};

export const Fund = {
  fundRiskRating,
  productCategory,
  isInvestor,
  closedToApplicationDescription,
  quotationRedemptionOrLiquidityTerm,
};

export const StructuredOperations = {
  structuredOperationsRiskRating,
  strategy,
  direction,
};

export const DirectTreasury = {
  riskRatingLevel: directTreasuryRiskRatingLevel,
  indexer: directTreasuryIndexerLevel,
  semiAnnual,
};

export const isOnlyProperties = [
  'quotationRedemptionOrLiquidityTerm',
  'closedToApplicationDescription',
  'dailyLiquidity',
  'fgcProtected',
  'taxExempt',
  'semiAnnual',
];
